/**
 * Path to a product's details page. A SKU may contain '/' (e.g. `DAN876/15WHEELS`), so it is
 * encoded as a single path segment. The `/products/:sku(.+)` route also accepts the raw slash, so
 * pasted or bookmarked URLs resolve too; vue-router hands the view the decoded SKU either way.
 */
export const productDetailsPath = (sku: string): string => `/products/${encodeURIComponent(sku)}`;
